import { Navigate, useParams } from 'react-router-dom';
import { ReviewLinkBuilder, SchemaGenerator, SeoChecklist, UtmBuilder } from './tools/FreeTools';

const TOOLS = {
  'schema-generator': SchemaGenerator,
  'utm-builder': UtmBuilder,
  'review-link': ReviewLinkBuilder,
  'local-seo-checklist': SeoChecklist,
};

export default function FreeToolPage() {
  const { slug } = useParams();
  const Tool = TOOLS[slug];
  if (!Tool) return <Navigate to="/free-tools" replace />;
  return <Tool />;
}
